import { useCallback, useEffect, useState } from "react";

import { ApiError, getTakeoff } from "@/api/client";
import type { Takeoff } from "@/api/client";

export interface TakeoffState {
  takeoff: Takeoff | null;
  loaded: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

/**
 * The take-off of a run: its sheets, its configurations with their colours, its totals.
 * `reload` after anything that changes a name, a merge or a decision.
 */
export function useTakeoff(runId: string): TakeoffState {
  const [takeoff, setTakeoff] = useState<Takeoff | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      setTakeoff(await getTakeoff(runId));
      setError(null);
    } catch (err) {
      setError(err instanceof ApiError ? err.detail : "could not load the take-off");
    } finally {
      setLoaded(true);
    }
  }, [runId]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { takeoff, loaded, error, reload };
}
